import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { get, includes } from 'lodash';
import classnames from 'classnames';
import categoryIcons from '../app-bookings-update/data/addOnCategoryIcons';
import { priceDisplayString } from './utils';
import { FormattedMessage, injectIntl, intlShape, defineMessages } from 'react-intl';

const Addon = ({ item, onClickAction = null, listingPageDisplay = false, intl }) => {
  // image_urls in top level in item object
  const backgroundImg = get(item, 'image_ids[0]');
  const isVisible = get(item, 'visible_on_listing');
  const itemCount = get(item, 'count');
  const itemCategory = get(item, 'category');
  const itemSubcategory = get(item, 'subcategory');
  const uniqueSubcategory = includes(['non-alcoholic_drinks', 'alcoholic_drinks', 'full_bar_package',
    'bar_services', 'backdrops', 'lighting', 'props', 'grips', 'power_supplies', 'ladder'], itemSubcategory);
  const itemIcon = uniqueSubcategory ? categoryIcons[itemSubcategory] : categoryIcons[itemCategory];
  const iconSrc = `/web-hosting/assets/images/${itemIcon}.svg?v=rb`;
  const imgUrl = `https://img.peerspace.com/image/upload/${backgroundImg}.jpg`;
  const listingPagePlaceholder = listingPageDisplay && !backgroundImg;

  const addOnStyling = {
    minHeight: '96px',
    width: '96px',
    padding: '0 7px',
    borderRadius: '2px',
    backgroundImage: backgroundImg ? `url(${imgUrl})` : null,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: (!get(item, 'visible_on_listing') || listingPagePlaceholder) ? '#F8F9FA' : null,
    border: !backgroundImg && isVisible && !listingPagePlaceholder ? '1px solid #DDE0E6' : null
  };

  const translationMessage = defineMessages({
    itemImageAlt: {
      id: 'hosting.add_on.item_icon_alt',
      defaultMessage: '{itemIcon} Icon'
    },
    addOnsImageAlt: {
      id: 'hosting.add_on.add_ons_image_alt',
      defaultMessage: 'add photo'
    },
    hiddenAddOnsImageAlt: {
      id: 'hosting.add_on.hidden_add_ons_image_alt',
      defaultMessage: 'hidden add-on'
    }
  });

  const listingPagePlaceholderDisplay = (
    <div className="flex column center">
      <div>
        {
          itemIcon &&
          <img className="icon no-margin" src={iconSrc} alt={ intl.formatMessage(translationMessage.itemImageAlt, { itemIcon: itemIcon }) } />
        }
      </div>
    </div>
  );

  const addPhotoPlaceholder = (
    <div className="add-photo flex column center">
      <div>
        <img className="icon" src='/web-hosting/assets/images/add-ons-large.svg?v=rb' alt={ intl.formatMessage(translationMessage.addOnsImageAlt)}/>
      </div>

      <div className="text-small text-gray-800 heavy margin-sm-top">
        <FormattedMessage
          id="hosting.add_on.add_photo"
          defaultMessage="Add Photo"
        />
      </div>
    </div>
  );

  const hiddenPlaceholder = (
    <div className={classnames('hidden-add-on flex column center', { 'hidden-overlay-photo': backgroundImg })}>
      <div>
        <img className="icon" src='/web-hosting/assets/images/hidden-add-on.svg?v=rb' alt={ intl.formatMessage(translationMessage.hiddenAddOnsImageAlt) }/>
      </div>

      <div className="text-small text-gray-800 heavy margin-sm-top">
        <FormattedMessage
          id="hosting.add_on.hidden"
          defaultMessage="Hidden"
        />
      </div>
    </div>
  );

  return (
    <div
      className="Addon flex margin-xl-bottom"
      onClick={() => onClickAction(item)}
    >
      <div className={classnames({ 'hidden-add-on-overlay': !isVisible })}></div>

      <LazyLoad offset={25} once>
        <div className="addon-image margin-lg-right flex center middle" style={ addOnStyling }>
          {
            listingPagePlaceholder ?
              listingPagePlaceholderDisplay
              :
              !isVisible ?
                hiddenPlaceholder
                :
                !backgroundImg ?
                  addPhotoPlaceholder
                  :
                  null
          }
        </div>
      </LazyLoad>

      <div className="ellipsis flex column center">
        <div className="label addon-title">{item.label}</div>
        <div className="text-small">
          {priceDisplayString(get(item, 'currency.symbol', '$'), item.unit_cost, item.unit_cost_basis)}
          {
            1 < itemCount &&
            <span><span className="text-gray-400"> ● </span>
              <FormattedMessage
                id="hosting.add_on.item_count_max"
                defaultMessage="{itemCount} max"
                values={{
                  itemCount: itemCount
                }}
              />
            </span>
          }
        </div>
        { !listingPageDisplay && <div className="text-small ellipsis text-gray-600">{item.description}&nbsp;</div> }
      </div>
    </div>
  );
};

Addon.propTypes = {
  item: PropTypes.object,
  openEditAddonModal: PropTypes.func,
  intl: intlShape
};

export default injectIntl(Addon);
